import React, { ReactNode, useContext, useEffect, createContext } from "react";
import { pendingOrders } from "../services/get-pending-order";


// interface ExtensionSyncProps {}

const ExtensionSyncContext  = createContext(undefined);

export const ExtensionSyncProvider : React.FC<{children:ReactNode}> = ({children}) => {
    useEffect(() => {
        const handleMessage = async (event: MessageEvent) => {
            if(event.source !== window || event.data.type !== "CARRY_EXTENSION") return;
            
            if(event.data.payload === "getPendingOrder") {
                console.log("Pending order requested");
                try {
                    const response = await pendingOrders();
                    if (response.order){
                        console.log("Pending order found");                    
                        window.postMessage({ type: "CARRY_APP", action: "orderSummary", data:response }, "*");
                    }
                }
                catch(e){
                    console.error(e);
                }
            }
        };
        window.addEventListener("message", handleMessage);
        return () => window.removeEventListener("message", handleMessage);
    },[]); 
    return (
        <ExtensionSyncContext.Provider value={undefined}>
            {children}
        </ExtensionSyncContext.Provider>
    )
}

export const useExtensionSync = () => {
    const context = useContext(ExtensionSyncContext);
    if(context === undefined){
        throw new Error("useExtensionSync must be used within a ExtensionSyncProvider");
    }
    return context;
}